import { axiosInstance } from '../assets/utils/axiosInstance';

export const userAuth = async (form) => {
  console.log('Tentative de connexion avec:', form);
  try {
    const res = await axiosInstance
      .post('/user/auth', {
        email: form.email.toLowerCase(),
        password: form.password,
      });
    console.log('Réponse de l\'API:', res);
    return res;
  } catch (err) {
    console.error('Erreur de connexion:', err);
    throw err;
  }
};

export const resetPassword = async (userId, password) => {
  const res = await axiosInstance
    .put(`/user/password/${userId}`, { password })
    .catch((err) => {
      console.log('resetPassword', err);
    });
  return res;
};

export const sendEmailResetPassword = async (email) => {
  const res = await axiosInstance
    .post(`/user/send-email-reset-password`, {
      email,
    })
    .catch((err) => {
      console.log('sendEmailResetPassword', err);
    });
  return res;
};
